<template>
  <div>
    <div class="com-banner" style="background-image:url(https://fs.58keeper.com/discount-bg.jpg)">
      <div class="banner-inner center">
        <h1>优选房源</h1>
        <p>精心布置，清洁消毒，美妙旅行的组成部分</p>
      </div>
    </div>
    <div class="section">
      <div class="com-container">
        <div class="t-center">
          <h2>海南全岛精选民宿，美妙旅程的组成部分</h2>
          <p>
            微信公众号搜索关注『大管家bigger』<br>
            或拨打 <a href="tel:13215835445">13215835445</a> 进行订房
          </p>
        </div>
      </div>
    </div>
    <div class="section">
      <div class="com-container">
        <div class="row">
          <div class="col-md-4 ds">
            <div>
              <a href="javascript:;" class="img">
                <img src="https://fs.58keeper.com/ds2.jpg" alt="多妙">
                <div class="cont-wrap">
                  <div class="cont f-cb">
                    <p>雅居乐清水湾</p>
                    <span class="cdate">陵水县英州镇 距离海边150米</span>
                  </div>
                </div>
                <span class="tags">海景</span>
              </a>
            </div>

            <div style="margin-top: 20px;">
              <a href="javascript:;" class="img">
                <img src="https://fs.58keeper.com/ds4.jpg" alt="多妙">
                <div class="cont-wrap">
                  <div class="cont f-cb">
                    <p>中海神州半岛</p>
                    <span class="cdate">万宁市东澳镇 距离海边100米</span>
                  </div>
                </div>
                <span class="tags type1">海景</span>
              </a>
            </div>
          </div>

          <div class="col-md-4 ds">
            <a href="javascript:;" class="img">
              <img src="https://fs.58keeper.com/ds1.jpg" alt="多妙">
              <div class="cont-wrap">
                <div class="cont f-cb">
                  <p>石梅山庄</p>
                  <span class="cdate">万宁市兴隆镇 距离海边5公里</span>
                </div>
              </div>
              <span class="tags type2">山景</span>
            </a>
          </div>

          <div class="col-md-4 ds">
            <a href="javascript:;" class="img">
              <img src="https://fs.58keeper.com/ds3.jpg" alt="多妙">
              <div class="cont-wrap">
                <div class="cont f-cb">
                  <p>清澜半岛</p>
                  <span class="cdate">文昌市清澜镇 距离海边150米</span>
                </div>
              </div>
              <span class="tags type2">海景</span>
            </a>
          </div>
        </div>

        <a href="https://i-zhenguo.meituan.com/profile/88374925" class="btn" id="loadmore">MORE</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'discount',
  data: function () {
    return {}
  },
  methods: {
  },
  mounted () {
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Discount.vue